import { useState } from "react";
import { threads } from "@/mocks/guaData";
import type { Thread } from "@/mocks/guaData";

const toneMap: Record<string, string> = {
  恋综: "bg-accent-100 text-accent-800",
  剧组: "bg-secondary-100 text-secondary-800",
  职场: "bg-primary-100 text-primary-700",
  综艺: "bg-secondary-100 text-secondary-800",
  数码: "bg-primary-100 text-primary-700",
  生活: "bg-accent-50 text-accent-700",
};

function ThreadRow({ t }: { t: Thread }) {
  const [liked, setLiked] = useState(false);
  return (
    <li className="rounded-xl border border-background-200 bg-background-50 p-4 transition hover:border-primary-200">
      <div className="flex items-center gap-2">
        {t.pinned && (
          <span className="inline-flex items-center gap-1 rounded bg-primary-500 px-1.5 py-0.5 text-[10px] font-medium text-background-50">
            <i className="ri-pushpin-2-line text-xs"></i>置顶
          </span>
        )}
        <span className={`whitespace-nowrap rounded px-2 py-0.5 text-xs font-medium ${toneMap[t.tag]}`}>{t.tag}</span>
        <h4 className="truncate font-medium text-foreground-900">{t.title}</h4>
      </div>
      <p className="mt-1.5 text-sm leading-relaxed text-foreground-600 line-clamp-1">{t.excerpt}</p>
      <div className="mt-3 flex items-center justify-between">
        <div className="flex items-center gap-2 text-xs text-foreground-500">
          <span className="flex h-6 w-6 items-center justify-center rounded-full bg-secondary-100 text-[10px] font-bold text-secondary-800">
            {t.author[0]}
          </span>
          <span className="whitespace-nowrap">{t.author}</span>
          <span className="whitespace-nowrap">· {t.time}</span>
        </div>
        <div className="flex items-center gap-3 text-xs text-foreground-500">
          <span className="inline-flex items-center gap-1"><i className="ri-eye-line"></i>{t.views >= 1000 ? `${(t.views / 1000).toFixed(1)}千` : t.views}</span>
          <span className="inline-flex items-center gap-1"><i className="ri-chat-3-line"></i>{t.replies}</span>
          <button
            onClick={() => setLiked((v) => !v)}
            className={`inline-flex items-center gap-1 whitespace-nowrap transition ${liked ? "text-primary-600" : "hover:text-primary-600"}`}
            aria-pressed={liked}
          >
            <i className={liked ? "ri-heart-fill" : "ri-heart-line"}></i>
            {t.likes + (liked ? 1 : 0)}
          </button>
        </div>
      </div>
    </li>
  );
}

export default function Discussion() {
  return (
    <section id="discuss" className="bg-background-100/60 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="flex items-center gap-2 text-sm font-medium text-secondary-700">
              <span className="inline-block h-4 w-1 rounded-full bg-secondary-500"></span>
              吃瓜讨论区
            </p>
            <h2 className="mt-2 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
              一起聊聊，别让瓜冷掉
            </h2>
          </div>
          <button className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition hover:bg-primary-600">
            <i className="ri-add-circle-line"></i>发起新话题
          </button>
        </div>

        <ul className="mt-8 space-y-3">
          {threads.map((t) => (
            <ThreadRow key={t.id} t={t} />
          ))}
        </ul>

        <div className="mt-6 flex justify-center">
          <button className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2 text-sm font-medium text-foreground-700 transition hover:border-primary-300 hover:text-primary-700">
            加载更多讨论
            <i className="ri-loader-4-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}